// eslint-disable-next-line @typescript-eslint/naming-convention
export enum SCREEN_SIZES {
  sm = 480,
  md = 768,
  lg = 992,
  xl = 1200,
}
